import React from 'react'
import SocialLinks from './SocialLinks'

const Banner = () => (
  <div className="row banner">
    <div className="banner-text">
      <h1 className="responsive-headline">Hi, I'm William</h1>
      <h3>
        <span>Product-focused entrepreneur</span> experienced in building and
        leading organizations.
      </h3>
      <hr />
      <SocialLinks />
    </div>
  </div>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js